<template>
    <el-dialog title="设置子产品" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form" ref="form">
        <RelationProduct :form="form" :type="type"></RelationProduct>
    </el-form>
    <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="edit" :loading="loading">确 定</el-button>
    </div>
    </el-dialog>
</template>

<script>
  import RelationProduct from './Relationproduct.vue';
    import ProductApi from '@/api/product.js';
    export default {
        components:{
            RelationProduct
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                wholesaleList:[],
                type:"edit",
                form:{
                    product:[]
                }
            };
        },
        props: ['is_open_scp','product_sku'],
       
        created() {
            
            this.dialogVisible = this.$parent.is_open_scp;
            //获取子产品
            this.list();
        },
        methods: {
            
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            },
            list(){
                let self =this;
                let params = {};
                params = this.form;
                console.log(params)
                params.product_sku =self.product_sku 
                params.product = params.product
                ProductApi.getSkuChildProduct(params, true)
                .then(data => {
                    self.loading = false;
                    if(data.data){
                        self.form.product = data.data
                    }else{
                        self.form.product = [];
                    }
                   
                })
                .catch(error => {
                self.loading = false;
                });
            },
            edit(){
                let self =this;
                let params = {};
                params = this.form;
                console.log(params)
                params.product_sku =self.product_sku 
                params.product = params.product
                ProductApi.addSkuChildProduct(params, true)
                .then(data => {
                    self.loading = false;
                    self.dialogFormVisible(1);
                })
                .catch(error => {
                self.loading = false;
                });
                    
            },
            removeWholesale(index){
                // var index = this.wholesaleList.domains.indexOf(item)
                if (index !== -1) {
                    this.form.product.splice(index, 1)
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/sku/part/SetChildProduct.vue